import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {SharedModule} from 'app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { GlobalState } from '../global.state';
import { ScrollTopComponent } from './scroll-top.component';

@NgModule({
    declarations: [
        ScrollTopComponent
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        RouterModule
    ],
    exports: [
        ScrollTopComponent
    ],
    providers :[
        GlobalState,
    ]
})
export class ScrollTopModule {
}
